/*
 * *
 *   ~  * Copyright (c) by INFODATA-GROUP. All rights reserved.
 *   ~  * No part of this publication may be reproduced, distributed,
 *   ~  * or transmitted in any form or by any means, including photocopying, recording,
 *   ~  * or other electronic or mechanical methods, without the prior written permission of the publisher,
 *   ~  * except in the case of brief quotations embodied in critical
 *   ~  * reviews and certain other noncommercial uses permitted by copyright law.
 *   ~  * AUTHOR : bs
 *   ~  * DATE : 29/04/2025 17:35
 *
 */

import { Component, EventEmitter, input, Output } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { ActionEvent, StandardAction } from '@infodata-group/inf-commons';
import { ButtonComponent } from '@infodata-group/inf-commons-desktop';

@Component({
  selector: 'infl-standard-page-error',
  standalone: true,
  imports: [TranslateModule, ButtonComponent],
  templateUrl: './standard-page-error.component.html',
  styleUrl: './standard-page-error.component.scss',
})
export class StandardPageErrorComponent {
  public errorTitle = input.required<string>();
  public errorText = input.required<string>();
  @Output() actionClick = new EventEmitter<ActionEvent>();

  protected onButtonClick() {
    this.actionClick.emit(
      new ActionEvent('click', new StandardAction('retry', '')),
    );
  }
}
